const PRESS_ITEMS = [
  { img: "fortune-italia.png", alt: "Fortune Italia", url: "https://www.fortuneita.com/2026/10/28/perche-gli-italiani-scoprono-tardi-uno-strumento-che-il-resto-del-mondo-usa-da-decenni-il-commento-di-bruno-benvenuti/" },
  { img: "economy-magazine.png", alt: "Economy Magazine", url: "https://www.economymagazine.it/il-trust-in-italia-tra-disinformazione-e-nuovi-rischi-patrimoniali/" },
  { img: "la-repubblica.png", alt: "la Repubblica Finanza", url: "https://finanza.repubblica.it/mobile/News/2026/10/27/ricchezza_netta_famiglie_a_11_732_miliardi_il_trust_nella_pianificazione_patrimoniale-37/" },
  { img: "la-stampa.png", alt: "La Stampa", url: "https://finanza.lastampa.it/News/2026/10/27/ricchezza-netta-famiglie-a-11-732-miliardi-il-trust-nella-pianificazione-patrimoniale/MzdfMjAyNi0xMC0yN19UTEI" },
  { img: "il-secolo-xix.png", alt: "Il Secolo XIX", url: "https://ilsecoloxixfinanza.teleborsa.it/News/2026/10/10/Ricchezza-netta-famiglie-a-11732-miliardi-il-Trust-nella-pianificazione-patrimoniale/?_tlbcId=4&_tlbData=MzdfMjAyNi0xMC0yN19UTEI&_tlbcParent=2" },
  { img: "qds-it.png", alt: "QdS.it", url: "https://qds.it/dai-mercati?guid=37_2026-10-27_TLB" },
  { img: "ansa-it.png", alt: "ANSA.it", url: "https://teleborsa.ansa.it/notiziario/economia/ricchezza-netta-famiglie-a-11-732-miliardi-il-trust-nella-pianificazione-patrimoniale/" },
  { img: "venti-di-economia.png", alt: "Venti di Economia", url: "https://ventidieconomia.it/2026/borsa/ricchezza-netta-famiglie-a-11-732-miliardi-il-trust-nella-pianificazione-patrimoniale/" },
  { img: "borsa-italiana.png", alt: "Borsa Italiana", url: "https://www.borsaitaliana.it/borsa/notizie/teleborsa/economia/ricchezza-netta-famiglie-a-11732-miliardi-il-trust-nella-pianificazione-patrimoniale-37_2026-10-27_TLB.html" },
  { img: "teleborsa.png", alt: "Teleborsa", url: "https://www.teleborsa.it/News/2026/10/27/ricchezza-netta-famiglie-a-11-732-miliardi-il-trust-nella-pianificazione-patrimoniale-37.html" },
];

export const PressStrip = ({ label }) => (
  <div className="press-strip" data-testid="press-strip">
    <div className="press-label">{label}</div>
    <div className="press-ticker">
      <div className="press-track">
        {[0, 1].map((copy) => (
          <ul key={copy} className="press-group" aria-hidden={copy === 1}>
            {PRESS_ITEMS.map((p) => (
              <li key={`${copy}-${p.img}`}>
                <a
                  className="press-item"
                  href={p.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  tabIndex={copy === 1 ? -1 : 0}
                  title={copy === 0 ? `${p.alt} — apri l'articolo in una nuova scheda` : undefined}
                  data-testid={copy === 0 ? `press-link-${p.img.replace(".png", "")}` : undefined}
                >
                  <img src={`/press/${p.img}`} alt={copy === 0 ? p.alt : ""} loading="lazy" />
                </a>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  </div>
);
